import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-m-1" }
const _hoisted_2 = { class: "p-field p-float-label p-col-12 p-mt-2" }
const _hoisted_3 = {
  for: "availableAlg",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-wizard-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.descriptor.style.dialog,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.alDialog.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: !_ctx.selectedAlgorithm,
        onClick: _ctx.changeAlgorithm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode(_component_InlineMessage, {
          class: "p-m-1 p-col-12",
          severity: "info",
          closable: "false"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.alDialog.infoMsg')), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            id: "availableAlg",
            class: "kn-material-input",
            modelValue: _ctx.selectedAlgorithm,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedAlgorithm = $event)),
            options: _ctx.availableAlgorithms,
            optionLabel: "name"
          }, null, 8, ["modelValue", "options"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.olap.alDialog.availableAlg')), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}